import {makeAutoObservable} from 'mobx';
import filtersStore from '../filters/filters-store/filters-store';
import {DEFAULT_PRICE_MAX, DEFAULT_PRICE_MIN} from '../filters/url/store-selection';

class PriceRangeStore {
    public min: number = DEFAULT_PRICE_MIN;
    public max: number = DEFAULT_PRICE_MAX;
    public range: number[] = [this.min, this.max];

    constructor() {
        makeAutoObservable(this);
        this.range = [filtersStore.filters.priceMin, filtersStore.filters.priceMax];
        filtersStore.registerPriceRangeListener((min, max) => {
            this.replaceRange([min, max]);
        });
    }

    /** Moves the slider to `range` without requesting products. URL restore uses this too. */
    replaceRange = (range: number[]) => {
        if (this.range[0] === range[0] && this.range[1] === range[1]) {
            return;
        }

        this.range = [range[0], range[1]];
    };

    setPriceRange = async (range: number[], forceRender = false) => {
        if (forceRender || this.range[0] !== range[0]) {
            await filtersStore.updateFilter('priceMin', range[0]);
        }

        if (forceRender || this.range[1] !== range[1]) {
            await filtersStore.updateFilter('priceMax', range[1]);
        }

        this.range = range;
    };

    setMinValue = async (value: number) => {
        if (!Number.isFinite(value) || !Number.isInteger(value)) {
            return;
        }

        if (value === 0 || value > this.max) {
            await this.setPriceRange([this.min, this.range[1]], value !== this.min);

            return;
        }

        if (value >= this.min && value <= this.range[1]) {
            await this.setPriceRange([value, this.range[1]]);
        }
    };

    setMaxValue = async (value: number) => {
        if (!Number.isFinite(value) || !Number.isInteger(value)) {
            return;
        }

        if (value === 0 || value > this.max) {
            await this.setPriceRange([this.range[0], this.max], value !== this.max);

            return;
        }

        if (value > this.min && value >= this.range[0]) {
            await this.setPriceRange([this.range[0], value]);
        }
    };
}

const priceRangeStore = new PriceRangeStore();

export default priceRangeStore;
